import { platform } from 'mutants-util';
class env {
    static verticalTouch(){
        const { isVerticalTouch } = platform || {};
        return !!isVerticalTouch;
    }

    static horizontalPad() {
        const { isHorizontalPad } = platform || {};
        return !!isHorizontalPad;
    }

    static horizontalSunMi() {
        const { isHorizontalSunMi  } = platform || {};
        return !!isHorizontalSunMi ;
    }
}
export default env;